import React, { useState } from 'react';
import { history } from '../../../../../_helpers/history';
import { formService as service } from '../../../../../_services/form.service';
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

import moment from 'moment';
import AvailableOn from '../../../Schedule/Component/AvailableOn';
import ProviderOptions from './Components/ProviderOptions';
import LocationOptions from './Components/LocationOptions';
import ReactDatePicker from '../../../../../_components/DatePicker/ReactDatePicker';
import RenderValidateMessage from '../../../../../stories/Validation/RenderValidateMessage';

function RescheduleAction({ form }) {
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [provider, setProvider] = useState(null);
  const [location, setLocation] = useState(null);
  const [rescheduling, setRescheduling] = useState(false);
  const [availableOn, setAvailableOn] = useState(null);
  const [completeByDate, setAppointmentDate] = useState(null);


  const [failedMsg, setFailedMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleShow = () => {
    setProvider(form.doctor.id);
    setLocation(form.providerGroup.id);
    setAvailableOn(form.availableOn ? moment(form.availableOn.date).toDate() : "");
    setAppointmentDate(moment(form.completeByDate.date).toDate());
    setShow(true);
  }

  const handleClose = () => {
    setProvider(null);
    setLocation(null);
    setAvailableOn(null);
    setAppointmentDate(null);
    setShow(false);
  }

  const validate = (e) => {
    e.preventDefault();

    let errors = {};

    if (!completeByDate) {
      errors.dateTime = 'Complete By Date is required.'
    } else if (moment(completeByDate).isBefore(new Date())) {
      errors.dateTime = 'Complete By Date must be upcoming.';
    }

    if (!location) {
      errors.group = 'Location is required.'
    }

    if (!provider) {
      errors.provider = 'Provider is required.'
    }

    if (form.status !== 'COMPLETED') {
      if (availableOn && moment(availableOn).isSameOrBefore(moment())) {
        errors.availableOn = 'Available On must be an upcoming date.';
      }

      if (availableOn && completeByDate && moment(availableOn).isSameOrAfter(moment(completeByDate))) {
        errors.availableOn = 'Available On must be before Complete By Date.';
      }
    }

    setErrors(errors);

    if (!errors.dateTime && !errors.provider && !errors.group && !errors.availableOn) {
      rescheduleForm();
    }
  }

  const rescheduleForm = () => {
    setRescheduling(true);
    setSuccessMsg('');
    setFailedMsg('');

    const availableOnFormat = availableOn && form.status !== 'COMPLETED' ? moment(availableOn).format('YYYY-MM-DD HH:mm') : "";

    service.rescheduleForm(form, completeByDate, provider, location, availableOnFormat)
      .then(() => {
        setRescheduling(false);
        setSuccessMsg('Successful reschedule');

        setTimeout(() => {
          handleClose();
          history.go(0);
        }, 1500);
      })
      .catch(() => {
        setRescheduling(false);
        setFailedMsg('Could not reschedule at this time. Please try again later.');
      });
  }

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Reschedule</Tooltip>}
    >
      <button
        title="Reschedule"
        onClick={handleShow}
        className="btn btn-outline-primary btn-sm">
        <i className="fas fa-edit" aria-hidden="true"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule Form</Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-0">
        {successMsg && <div className="alert alert-success mt-3">{successMsg}</div>}
        {failedMsg && <div className="alert alert-danger mt-3">{failedMsg}</div>}

        <form className="mt-4">
          <div className="form-group">
            <label><span className="text-danger">*</span> Provider</label> &nbsp;
            <ProviderOptions form={form} providerChanged={provider => setProvider(provider)} />
            <RenderValidateMessage errors={errors} field="provider" />
          </div>
          <div className="form-group">
            <label><span className="text-danger">*</span> Location</label> &nbsp;
            <LocationOptions form={form} locationChanged={location => setLocation(location)} />
            <RenderValidateMessage errors={errors} field="group" />
          </div>
          <div className="form-group">
            <label><span className="text-danger">*</span> Complete By</label> &nbsp;
            <ReactDatePicker
              selected={completeByDate}
              onChange={(date) => { setAppointmentDate(date); }}
              minDate={new Date()}
              minTime={moment().set('hours', 6).set('minute', 0).toDate()}
              maxTime={moment().set('hours', 18).set('minute', 0).toDate()}
              showTimeSelect
              timeFormat="hh:mm aa"
              timeIntervals={5}
              timeCaption="Time"
              dateFormat="MMM d, yyyy h:mm aa"
              className="form-control"
              wrapperClassName="w-100"
            />
            <RenderValidateMessage errors={errors} field="dateTime" />
          </div>
          {form.status !== "COMPLETED" &&
            <div className="form-group">
              <AvailableOn
                sendOn={availableOn}
                setAvailableOn={(date) => setAvailableOn(date)}
                apptDate={completeByDate}
                apptType={'axs-link'}
              />
              <RenderValidateMessage errors={errors} field="availableOn" />
            </div>
          }
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={validate}
          disabled={rescheduling}
          variant="primary"
        >
          {rescheduling ? 'Rescheduling...' : 'Reschedule'}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default RescheduleAction;